import { useCallback } from "react";
import axios from "axios";
import { verifyTokenExpire } from "middleware/verifyToken";
import { DeleteConfirmation } from "views/components/ConfirmationAlert";
import { confirmDeleteConfig } from "config/confirmConfig";
import { ToastBottomEnd } from "views/components/Toast";
import {
  toastDeleteErrorMessageConfig,
  toastDeleteSuccessMessageConfig,
} from "config/toastConfig";
import { forceRound } from "helpers/function";

export const useDeleteReport = (
  rapportAuto,
  setRapportAuto,
  endPoint,
  numberPerPage,
  activeNumberPage,
  showList
) => {
  const getEndByPosition = useCallback(
    (position) => {
      let end = numberPerPage;
      for (let i = 1; i < position; i++) {
        end = end + numberPerPage;
      }
      return end;
    },
    [numberPerPage]
  );

  const deleteReport = useCallback(
    async (rapportAutoId, index) => {
      try {
        const result = await DeleteConfirmation.fire(confirmDeleteConfig());

        if (result.value && verifyTokenExpire()) {
          await axios.delete(`${endPoint.list}/${rapportAutoId}`);

          const newRapport = [...rapportAuto];
          newRapport.splice(index, 1);
          setRapportAuto(newRapport);

          const updatePagination = () => {
            if (showList.length > 1) {
              const startIndex =
                getEndByPosition(activeNumberPage) - numberPerPage;
              const endIndex = getEndByPosition(activeNumberPage);
              return {
                newShowList: newRapport.slice(startIndex, endIndex),
                newActivePage: activeNumberPage,
              };
            } else {
              const prevPage = Math.max(1, activeNumberPage - 1);
              const startIndex = getEndByPosition(prevPage) - numberPerPage;
              const endIndex = getEndByPosition(prevPage);
              return {
                newShowList: newRapport.slice(startIndex, endIndex),
                newActivePage: prevPage,
              };
            }
          };

          const { newShowList, newActivePage } = updatePagination();

          const newNumberPage = forceRound(newRapport.length / numberPerPage);

          ToastBottomEnd.fire(toastDeleteSuccessMessageConfig());

          return {
            success: true,
            newData: newRapport,
            newShowList,
            newActivePage,
            newNumberPage,
          };
        }
      } catch (error) {
        console.error("Error deleting report:", error);
        ToastBottomEnd.fire(toastDeleteErrorMessageConfig());
        return { success: false };
      }
    },
    [
      rapportAuto,
      setRapportAuto,
      endPoint,
      numberPerPage,
      activeNumberPage,
      showList,
      getEndByPosition,
    ]
  );

  return {
    deleteReport,
  };
};
